import { LoginResponse } from '@app/interfaces/login-response.interface';

export abstract class SessionBaseService {
  abstract getCurrentToken(): string;
  abstract getCurrentContext(): string;
  abstract logout(): void;
  abstract startNewSession(response: LoginResponse): void;
}
